module.exports = __webpack_public_path__ + "static/img/service_introduce_5115_zh.34a0508.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_introduce_5115_zh.png
// module id = y5w0
// module chunks = 34